import clsx from 'clsx';
import React from 'react';

import AmpchargeIcon from './ampcharge-icon.svg?react';
import NotificationIcon from './notification-icon.svg?react';

import styles from './InfoBanner.module.scss';

/**
 * Display a static banner
 * @param message Required message to be displayed
 * @param type Required type of the banner
 */
export const InfoBanner = ({ message, type }) => {
  const getIcon = () => {
    switch (type) {
      case 'ampcharge':
        return <AmpchargeIcon className={clsx(styles.infoBannerIcon)} aria-label='Ampcharge logo' />;
      default:
        return <NotificationIcon className={clsx(styles.infoBannerIcon)} aria-label='Notification icon' />;
    }
  };

  return (
    <div className={clsx(styles.infoBanner, styles[`infoBanner__${type}`])} data-testid='InfoBanner'>
      {getIcon()}
      {message && <span>{message}</span>}
    </div>
  );
};

export default InfoBanner;
